import { BaseModel } from './base-model';

export class MarkupHistory extends BaseModel {
  // for CASL subject detection on code minification
  static get modelName() {
    return 'MarkupHistory';
  }

  /* tslint:disable */
  version: number;
  annotation_data: any;
  canvas_width: number;
  canvas_height: number;
  /* tslint:enable */
}
